export default __webpack_public_path__ + "static/media/full-human.5e8438ba.jpg";